import type { ChatToken } from 'lib/chat/chat.schema';
import { ChatTokenResponseSchema } from 'lib/chat/chat.schema';
import { logger } from 'lib/utils/logger';

export async function getChatToken(token: string) {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_CONSUMER_SERVICE_URL}/auth/chat`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) {
    if (response.status !== 404) {
      logger.error(response, 'Failed to get chat token');
    }
  }

  const chatToken = await response.json();

  const parsedToken = ChatTokenResponseSchema.safeParse(chatToken);

  if (!parsedToken.success) {
    logger.error(parsedToken.error, `Failed to parse chat token`);
  }

  return parsedToken.success ? parsedToken.data : (chatToken as ChatToken);
}
